var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditorAddGroupBranch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1181_1857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 15.5C18.2165 15.5 19 14.7165 19 13.75C19 12.7835 18.2165 12 17.25 12C16.2835 12 15.5 12.7835 15.5 13.75C15.5 14.7165 16.2835 15.5 17.25 15.5Z",
    stroke: "#98BDBD",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 8.5C11.2165 8.5 12 7.7165 12 6.75C12 5.7835 11.2165 5 10.25 5C9.2835 5 8.5 5.7835 8.5 6.75C8.5 7.7165 9.2835 8.5 10.25 8.5Z",
    stroke: "#98BDBD",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 8.5C10.25 9.89239 10.8031 11.2277 11.7877 12.2123C12.7723 13.1969 14.1076 13.75 15.5 13.75",
    stroke: "#98BDBD",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25 15.5C2.2835 15.5 1.5 14.7165 1.5 13.75C1.5 12.7835 2.2835 12 3.25 12C4.2165 12 5 12.7835 5 13.75C5 14.7165 4.2165 15.5 3.25 15.5Z",
    stroke: "#98BDBD",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 8.5C10.25 9.89239 9.69688 11.2277 8.71231 12.2123C7.72774 13.1969 6.39239 13.75 5 13.75",
    stroke: "#98BDBD",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7222 6.96875V6.44792C18.7222 6.17165 18.6052 5.9067 18.3968 5.71135C18.1884 5.516 17.9058 5.40625 17.6111 5.40625H15.3889C15.0942 5.40625 14.8116 5.516 14.6032 5.71135C14.3948 5.9067 14.2778 6.17165 14.2778 6.44792V6.96875",
    stroke: "#98BDBD",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4.36458C17.1136 4.36458 17.6111 3.89821 17.6111 3.32292C17.6111 2.74762 17.1136 2.28125 16.5 2.28125C15.8863 2.28125 15.3889 2.74762 15.3889 3.32292C15.3889 3.89821 15.8863 4.36458 16.5 4.36458Z",
    stroke: "#98BDBD",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.72222 6.96875V6.44792C5.72222 6.17165 5.60515 5.9067 5.39678 5.71135C5.1884 5.516 4.90579 5.40625 4.6111 5.40625H2.38888C2.0942 5.40625 1.81158 5.516 1.60321 5.71135C1.39483 5.9067 1.27777 6.17165 1.27777 6.44792V6.96875",
    stroke: "#98BDBD",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4.36458C4.11365 4.36458 4.61111 3.89821 4.61111 3.32292C4.61111 2.74762 4.11365 2.28125 3.5 2.28125C2.88635 2.28125 2.38889 2.74762 2.38889 3.32292C2.38889 3.89821 2.88635 4.36458 3.5 4.36458Z",
    stroke: "#98BDBD",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1181_1857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(20 0.5) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorAddGroupBranch);
export default __webpack_public_path__ + "static/media/editor_add_group_branch.3b0d632c4acc1715b9ae8d775fb4cbe2.svg";
export { ForwardRef as ReactComponent };